import { render, staticRenderFns } from "./TriggerDetails.vue?vue&type=template&id=c0942e60"
import script from "./TriggerDetails.vue?vue&type=script&lang=js"
export * from "./TriggerDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports